<template>
    <NuxtLink
        class="button-link"
        :class="{
            'button-link--small': small,
            'button-link--large': large,
            'button-link--responsive': !small && !large,
            'button-link--hover': hover
        }"
        v-bind="$attrs"
    >
        <Icon v-if="icon && iconPosition === 'left'" class="left" :name="icon" />
        <slot />
        <Icon v-if="icon && iconPosition === 'right'" class="right" :name="icon" />
    </NuxtLink>
</template>

<script setup>
defineProps({
    small: {
        type: Boolean,
        default: false
    },
    large: {
        type: Boolean,
        default: false
    },
    icon: {
        type: String,
        default: null
    },
    iconPosition: {
        type: String,
        default: 'right'
    },
    hover: {
        type: Boolean,
        default: false
    }
});
</script>

<style src="./ButtonLink.less" lang="less" />
